import React, { useMemo } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

export type ButtonProps = {
    children: React.ReactNode;
    type?: "primary" | "secondary" | "tertiary" | "transparent" | string;
    className?: string;
    textSize?: string;
    disabled?: boolean;
    padding?: string;
    loader?: boolean;
    title?: string;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    childrenWrapperClassName?: string;
    arrow?: boolean;
    style?: React.CSSProperties;
};

export default function Button({
    children,
    type = "primary",
    className,
    padding = "py-2 px-5",
    textSize = "text-base",
    disabled,
    title,
    loader = false,
    onClick,
    childrenWrapperClassName = "",
    style
}: ButtonProps) {
    disabled = disabled === null ? false : disabled;

    const textClass = useMemo(() => {
        switch (type) {
            case "secondary":
            case "tertiary":
                return "text-white";
            default:
                return "text-dark";
        }
    }, [type]);

    const disabledClass = useMemo(() => {
        return disabled ? "opacity-50" : "";
    }, [disabled]);

    return (
        <button
            style={style}
            onClick={onClick}
            disabled={disabled}
            title={title}
            className={`${textClass} bg-${type} ${disabledClass} ${padding} ${textSize} 
                font-extrabold relative flex justify-center items-center rounded uppercase
                ${className}`}
        >
            <div className={`flex items-center ${loader ? "opacity-0" : ""} ${childrenWrapperClassName}`}>
                {children}
            </div>
            {loader && (
                <div className="absolute top-0 left-0 h-full w-full flex justify-center items-center">
                    <AiOutlineLoading3Quarters className="animate-spin" size={16} />
                </div>
            )}
        </button>
    );
}
